import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditStoryComponent } from './edit-story.component';
import { EditorModule } from '../../../components/editor/editor.module';
import { SharedModule } from '../../../../shared/shared.module';
import { MatButtonModule } from '@angular/material/button';
import { PublishDialogModule } from '../../new-story/publish-dialog/publish-dialog.module';

const PIPES = []!;

const ANGULAR_MATERIAL_MODULES = [
  MatButtonModule
];

const CORE_MODULES = [CommonModule];

const COMPONENTS = [EditStoryComponent];

@NgModule({
  declarations: [...COMPONENTS, ...PIPES],
  imports: [
    ...CORE_MODULES, ...ANGULAR_MATERIAL_MODULES,
    EditorModule, SharedModule, PublishDialogModule
  ],
  exports: [...COMPONENTS]
})
export class EditStoryModule { }
